import React, {Component} from 'react';
import MetaTags from 'react-meta-tags';

import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';

// Components
import Anime from '../../components/Anime/Anime';

// Containers
import ContentHeader from '../../containers/ContentHeader/ContentHeader';
import CallToAction from '../../containers/CallToAction/CallToAction';

// Data
import FaqData from '../../data/Faq.json';

const GetFaq = props => {

    return FaqData.Faq.map((faqSection, i) => {
        if ( faqSection.group === props.group ) {
            return (
                <div key={i}>
                <h2>{faqSection.title}</h2>
                <Accordion allowZeroExpanded="true">
                    {faqSection.faqs.map(function (item, i) { 
                        return (
                            <div key={i}>
                                <AccordionItem>
                                    <AccordionItemHeading>
                                        <AccordionItemButton>
                                            {item.question}
                                        </AccordionItemButton>
                                    </AccordionItemHeading>
                                    <AccordionItemPanel>
                                        <p>{item.answer}</p>
                                    </AccordionItemPanel>
                                </AccordionItem>
                            </div>
                        );
                    })}
                </Accordion>
                </div>
            );
        } else {
            return false;
        }
    })

}

class PageFAQ extends Component {

     render () {
     
         return (
            <div className="app-section">
                <MetaTags>
                    <title>Frequently Answered Questions</title>
                    <meta 
                        name="description" 
                        content="Frequently Asked Questions." 
                    />
                </MetaTags>
                    <div className="container faq mb">
                        <ContentHeader 
                            title="F.A.Q" 
                            subTitle="" 
                            classes="" 
                        />

                        <div className="row row-large-gutter row-padding">
                            <div className="col-xl-6 col-12">
                                <Anime type="fade-up" delay="3" duration="3">
                                	<GetFaq group="general"/>
                                </Anime>
                                <Anime type="fade-up" delay="4" duration="3">
                                	<GetFaq group="technical"/>
                                </Anime>

                            </div>
                            <div className="col-xl-6 col-12 pb">
                            	<Anime type="fade-up" delay="5" duration="3">
                                	<GetFaq group="presales"/>
                                </Anime>
                            </div>
                        </div>
                    </div>
                <CallToAction 
                    buttonTitle="Get a Free Quote"
                    buttonLink="/contact"
                    text="You need professional support for your theme?"
                    classes="cta--full cta--color cta--center"
                />
            </div>

        );
    }
}

export default PageFAQ;


// WEBPACK FOOTER //
// ./src/pages/PageFAQ/PageFAQ.js